import * as types from './types';
import { SET_STICKY_MODE, SetStickyModeAction } from './types';

export const reloadHeader = (): types.ReloadHeaderAction => {
    return { type: types.RELOAD_HEADER };
};
export const reloadHeaderFinished = (): types.ReloadHeaderSuccessAction => {
    return { type: types.RELOAD_HEADER_SUCCESS };
};

export const setStickyMode = (isSticky: boolean): SetStickyModeAction => {
    return { type: SET_STICKY_MODE, payload: isSticky };
};
